import createSagaMiddleware from "redux-saga";
import { carMiddlewares, carReducers } from "@apac/cars";
import { disruptionRootReducer } from "@b2bportal/core-disruption";
import {
  flightRtkQueryReducers,
  flightsPostBookingApi,
  flightsRootReducer,
} from "@b2bportal/core-flights";
import { hotelReducers, hotelMiddlewares } from "@b2bportal/core-hotels";
import { selfServeRootReducer } from "@b2bportal/core-self-serve";
import { tripsRootReducer } from "@b2bportal/core-trips";
import { authReducer } from "@hopper-b2b/self-serve";
import { tenantFlightsMiddleware, tenantFlightsReducers } from "@hsbc/flights";
import {
  accountRewardsMiddleware,
  accountRewardsReducers,
} from "@hsbc/rewards";
import { walletMiddleware, walletReducers } from "@hsbc/wallet";
import {
  combineSlices,
  configureStore,
  createDynamicMiddleware,
} from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";

export const dynamicMiddleware = createDynamicMiddleware();
const sagaMiddleware = createSagaMiddleware();

const middleware = [
  sagaMiddleware,
  ...tenantFlightsMiddleware,
  ...accountRewardsMiddleware,
  ...walletMiddleware,
  ...hotelMiddlewares,
  ...carMiddlewares,
  flightsPostBookingApi.middleware,
];

export const reducer = combineSlices({
  auth: authReducer,
  flights: flightsRootReducer,
  trips: tripsRootReducer,
  disruption: disruptionRootReducer,
  ...hotelReducers,
  ...tenantFlightsReducers,
  ...accountRewardsReducers,
  ...walletReducers,
  ...carReducers,
  selfServe: selfServeRootReducer,
  ...flightRtkQueryReducers,
});

const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(middleware)
      .concat(dynamicMiddleware.middleware),
});

setupListeners(store.dispatch);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export default store;
